var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7290_104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9616 7.38328C33.3735 7.20993 33.8243 7.15014 34.2671 7.21014C34.7099 7.27013 35.1285 7.44772 35.4794 7.72442C35.8303 8.00111 36.1006 8.3668 36.2622 8.78341C36.4238 9.20003 36.4708 9.65234 36.3983 10.0933L32.6183 33.0216C32.2516 35.2333 29.825 36.5016 27.7966 35.3999C26.1 34.4783 23.58 33.0583 21.3133 31.5766C20.18 30.8349 16.7083 28.4599 17.135 26.7699C17.5016 25.3249 23.335 19.8949 26.6683 16.6666C27.9766 15.3983 27.38 14.6666 25.835 15.8333C21.9983 18.7299 15.8383 23.1349 13.8016 24.3749C12.005 25.4683 11.0683 25.6549 9.94828 25.4683C7.90495 25.1283 6.00995 24.6016 4.46328 23.9599C2.37328 23.0933 2.47495 20.2199 4.46162 19.3833L32.9616 7.38328Z",
    fill: "#0088CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7290_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram_icon.61640d6ceae75f85e35aede244fb7cbf.svg";
export { ForwardRef as ReactComponent };